// extracted by mini-css-extract-plugin
export default {"create":"Create_create__K-kxE","form":"Create_form__DPD6L"};